import React, { FC } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckinDetails } from './CheckinDetails';

export const CheckinDetailsRoute: FC = () => {
  const { checkinId } = useParams<{ checkinId: string }>();
  const navigate = useNavigate();

  if (!checkinId) {
    navigate('/onboarding-trainer/dashboard/messages?tab=checkins');
    return null;
  }

  return (
    <div
      className="dashboard-screen messages-screen"
      style={{ padding: 0, overflowY: 'hidden', height: '100%' }}
    >
      <CheckinDetails
        checkinId={checkinId}
        onBack={() => {
          if (window.history.length > 1) {
            navigate(-1);
          } else {
            navigate('/onboarding-trainer/dashboard/messages?tab=checkins');
          }
        }}
      />
    </div>
  );
};
